import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import AppIcons from '../../../assets/images/icons';
import focusBlk from '../../../assets/images/icons/focusBlk.svg';

import "./listing.scss"
import { ScrollToTopOnMount } from "../../../Components/ScrollToTop/ScrollToTop";
import SliderThumbPage from "./SliderThumbPage";
import { PropertyModel } from "../../../models/property.model";
import RichTextViewer from "../../../Components/RichText/RichTextViewer";
import SVGIcons from "../../../assets/images/icons/svgIcons";
import MapComponent from "../../../Components/MapSection";
import { Helmet } from "react-helmet-async";
import ApiCaller from '../../../services/api/APICaller';


import S3ImageViewerWithFallback from "../../../Components/awsS3ImageViewer/ImgViewerWithFallback";
import BlogListSlider from "../../../Components/blogRevamp/blogListSlider";


const PropertyDetails = () => {

  ScrollToTopOnMount();
  const params = useParams();
  // const navigate = useNavigate();
  const propId = params?.id || '';
  const propertyId = propId;
  const [property, setProperty] = useState(PropertyModel);

  ScrollToTopOnMount();

  /**
  the legendary use effect function
  This will run very first on render
   */
  useEffect(() => {
    if (propertyId) {
      getPropertyAs()
    }
    return () => {
      setProperty(null)
    };
    // eslint-disable-next-line
  }, []);

  // get users from api
  const getPropertyAs = () => {
    const apiCaller = new ApiCaller('properties/property-details');
    apiCaller.postData({title: propertyId}).then(({data})=> {
      setProperty(data)
    })
    // getProperty(propertyId).then((data) => setProperty(data)).catch(() => showSnackbar().failure('Something went wrong'))

  }

  return (
    <>
      {property?.title ? <Helmet>
        <title>{property?.title}</title>
        <link rel={property?.title} href="#" />

        {property?.title && <meta property="og:title" content={property?.title} />}
        {property?.metaTags && <meta name="keywords" content={property?.metaTags} />}
        {property?.metaDescription && <meta name="description" content={property?.metaDescription} />}
        {property?.metaDescription && <meta property="og:description" content={property?.metaDescription} />}

      </Helmet> : null}
      <div id='app-main-content' className="main-content-wrapper listing-wrapper listing-detail-wrp property-detail-revamp f-wrp">
        <div className="container">

          <div className="breadcrumb f-wrp">
            <Link to={'/exclusive-listings'}> <SVGIcons.BackIcon />&nbsp;&nbsp; All listings</Link> &nbsp; <SVGIcons.SeparatorIcon /> &nbsp;
            <Link to={'/'}> Home &nbsp;&nbsp;<SVGIcons.RightChevronIcon /></Link>&nbsp;
            {property?.operationType === 'rent' ? <><Link to={'/exclusive-listings?mode=rent'}>Property for Rent in Dubai &nbsp;&nbsp;<SVGIcons.RightChevronIcon /></Link>&nbsp;</> :
              property?.operationType === 'sell' ? <><Link to={'/exclusive-listings?mode=buy'}>Property for Sale in Dubai &nbsp;&nbsp;<SVGIcons.RightChevronIcon /></Link>&nbsp;</> :
                <><Link to={'/exclusive-listings'}>Property for Sale in Dubai &nbsp;&nbsp;<SVGIcons.RightChevronIcon /></Link>&nbsp;</>}


            <p>{property?.title}</p>
          </div>


          <div className="detail-slider-wrp f-wrp">

            {property?.images?.length ? <SliderThumbPage images={property?.images ? property?.images.map(img => img.tempURL) : []}
              thumbnails={(property?.thumbnails > 0) ? property?.thumbnails.filter((i) => i && i.tempURL).map(img => img.tempURL) : property?.images.filter((i) => i && i.tempURL).map(img => img.tempURL)} /> : null}
          </div>

          <div className="row mobRow" style={{ marginLeft: '-10px', width: 'calc(100% + 10px)' }}>
            <div className="col-lg-9 col-md-12 col-sm-12 col-xs-12" style={{ paddingLeft: '0', paddingRight: '8px' }}>


              <div className="property-detail-box f-wrp">
                <div className="each-detail-sec f-wrp">

                  {property?.price && <h1 className="price">{property?.price} AED</h1>}


                  <ul className="flex-list basic-detail-list f-wrp">
                    {property?.noOfBedrooms &&
                      <li>
                        <span className="list-icon"><SVGIcons.BedIcon /></span> Beds: {property?.noOfBedrooms}
                      </li>}
                    {property?.noOfBathrooms &&
                      <li>
                        <span className="list-icon"><SVGIcons.BathIcon /></span> Baths: {property?.noOfBathrooms}
                      </li>}
                    {property?.bua &&
                      <li>
                        <span className="list-icon"><img src={focusBlk} alt="focus-icon" /></span> BUA: {property?.bua} sft
                      </li>}
                    {property?.area &&
                      <li>
                        <span className="list-icon"><SVGIcons.AreaIcon /></span> Area: {property?.area} {property?.areaMeasureUnit}
                      </li>}
                  </ul>

                  {property?.title && <h1 className="title">{property?.title}</h1>}
                  {property?.subTitle && <h1 className="subTitle">{property?.subTitle}</h1>}
                </div>


                {(property?.description) ?
                  <div className="each-detail-sec f-wrp">
                    <h2 className="section-title">Property Description</h2>
                    {(property?.description) && <RichTextViewer richText={property?.description} />}
                  </div> : null}

                {(property?.features) ?
                  <div className="each-detail-sec feature-list f-wrp">
                    <h2 className="section-title">Features</h2>
                    {(property?.features) && <RichTextViewer richText={property?.features} />}
                  </div> : null}

                {(property?.amenities) ?
                  <div className="each-detail-sec f-wrp">
                    <h2 className="section-title">Amenities</h2>
                    <ul className="flex-list property-amenities-lists f-wrp">
                      {property?.amenities?.barbequeArea && <li>Barbeque area</li>}
                      {property?.amenities?.lawnOrGarden && <li>Lawn or garden</li>}
                      {property?.amenities?.cafeteria && <li>Cafeteria</li>}
                      {property?.amenities?.daycare && <li>Daycare</li>}
                      {property?.amenities?.kidsPlayArea && <li>Kids play area</li>}
                      {property?.amenities?.sundeck && <li>Sundeck</li>}
                      {property?.amenities?.laundryRoom && <li>Laundry room</li>}
                      {property?.amenities?.laundryFacility && <li>Laundry facility</li>}
                      {property?.amenities?.sharedKitchen && <li>Shared kitchen</li>}
                      {property?.amenities?.medicalCenter && <li>Medical center</li>}
                      {property?.amenities?.sauna && <li>Sauna</li>}
                      {property?.amenities?.jacuzzi && <li>Jacuzzi</li>}
                      {property?.amenities?.disabledFriendly && <li>Disabled friendly</li>}
                      {property?.amenities?.gym && <li>Gym</li>}
                      {property?.amenities?.healthClub && <li>Health club</li>}
                      {property?.amenities?.swimmingPool && <li>Swimming pool</li>}
                      {property?.amenities?.steamRoom && <li>Steam room</li>}
                      {property?.amenities?.balcony && <li>Balcony</li>}
                      {property?.amenities?.terrace && <li>Terrace</li>}
                      {property?.amenities?.lobby && <li>Lobby</li>}
                      {property?.amenities?.serviceElevators && <li>Service elevators</li>}
                      {property?.amenities?.prayerRoom && <li>Prayer room</li>}
                      {property?.amenities?.reception && <li>Reception</li>}
                      {property?.amenities?.atmFacility && <li>ATM facility</li>}
                      {property?.amenities?.concierge24h && <li>24h concierge</li>}
                      {property?.amenities?.maidsRoom && <li>Maids room</li>}
                      {property?.amenities?.bussinessCenter && <li>Bussiness center</li>}
                      {property?.amenities?.conferenceRoom && <li>Conference room</li>}
                      {property?.amenities?.securityStaff && <li>Security staff</li>}
                      {property?.amenities?.cctvSecurity && <li>CCTV security</li>}
                      {property?.amenities?.doubleGlazedWindows && <li>Double glazed windows</li>}
                      {property?.amenities?.centralyAirConditioned && <li>Centraly air-conditioned</li>}
                      {property?.amenities?.centalHeating && <li>Cental heating</li>}
                      {property?.amenities?.electricityBackup && <li>Electricity backup</li>}
                      {property?.amenities?.studyRoom && <li>Study room</li>}
                      {property?.amenities?.storageAreas && <li>Storage areas</li>}
                      {property?.amenities?.broadbandInternet && <li>Broadband internet</li>}
                      {property?.amenities?.sateliteCableTV && <li>Satelite/Cable TV</li>}
                      {property?.amenities?.intercom && <li>Intercom</li>}
                      {property?.amenities?.cleaningservices && <li>Cleaning services</li>}
                      {property?.amenities?.maintenanceStaff && <li>Maintenance staff</li>}
                      {property?.amenities?.wasteDisposal && <li>Waste disposal</li>}
                    </ul>
                  </div> : null}


                {(property?.location) ?
                  <div className="each-detail-sec location-section f-wrp">
                    <h2 className="section-title">Location</h2>
                    <h3><SVGIcons.MapPinIcon /> {property?.location}</h3>
                    <div className="map-wrp">
                      {(property?.latitude && property?.longitude) ?
                        <MapComponent
                          showMap
                          showSearchInput={false}
                          initialData={{
                            latitude: property?.latitude,
                            longitude: property?.longitude,
                            location: property?.location

                          }} />
                        : null}
                    </div>
                  </div> : null}


                {property?.category || property?.subcategory || property?.completionStatus || property?.operationType ?
                  <div className="each-detail-sec f-wrp">
                    <h2 className="section-title">Property details</h2>
                    <ul className="flex-list property-detail-list f-wrp" style={{ paddingTop: '0' }}>
                      {property?.category && <li>
                        <p>Category: </p> <b>{property?.category}</b>
                      </li>}
                      {property?.subcategory && <li>
                        <p>Subcategory: </p> <b>{property?.subcategory}</b>
                      </li>}
                      {property?.completionStatus &&
                        <li>
                          <p>Completion status: </p> <b>{property?.completionStatus}</b>
                        </li>}
                      {property?.operationType &&
                        <li>
                          <p>Purpose: </p> <b>{property?.operationType}</b>
                        </li>}
                    </ul>
                  </div> : null}

                {/* add the DLD permit update here */}

                {property?.permitNumber ? <div className="each-detail-sec f-wrp">

                  <div className="DLD-permit-box f-wrp">
                    <div className="DLD-qrBox">
                      <span className="QR-code">{property?.permitQRCode && <S3ImageViewerWithFallback fileKey={property?.permitQRCode} />}</span>
                    </div>
                    <div className="DLD-contentBox">
                      <h2 className="section-title">DLD Permit Number</h2>
                      <h3>{property?.permitNumber}</h3>
                      <p>This property listing has been reviewed and verified by Dubai Land Department</p>
                    </div>
                  </div>
                </div> : null}



              </div>
            </div>
            <div className="col-lg-3 col-md-12 col-sm-12 col-xs-12" style={{ paddingLeft: '4px', paddingRight: '0' }}>
              <div className="sticky-contact-box">
                <div className="agent-detail-wrp f-wrp">
                  <ul>
                    <li>
                      <div className="profile-blk">
                        <div className="img-box">
                          <span><img src={AppIcons.agentDefault} alt="agent" /></span>
                        </div>
                        <div className="agent-info-box">
                          <h4>{property?.agentName}</h4>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="contct-btn-sec f-wrp">
                        {/* <span className="whstapp-btn" onClick={() => window.open('https://wa.me/971568816886', '_blank')} ><SVGIcons.CallIcon /> Call</span> */}
                        <a className="whstapp-btn" href="tel:+971568816886" ><SVGIcons.CallIcon /> Call</a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="prop-detail-blog-sec f-wrp">
            <div className='article-revamp-wrapper'>
              <div className='blogListSlider f-wrp'>
                <BlogListSlider />
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default PropertyDetails;
